import { Icon } from "~/react/ui/icon"
import { Switch } from "~/react/ui/switch"
import { useCampaignContent } from "../campaign_content_context"
import { EmailEditorCard } from "./email_editor_card"
import { t } from "../i18n"

export function FollowUpEditor() {
  const { followUps, selectedStep, editable, abTestEnabled, setAbTestEnabled } =
    useCampaignContent()

  const currentFollowUp = followUps.find((fu) => fu.step === selectedStep)

  if (!currentFollowUp) {
    return null
  }

  const isOpeningEmail = currentFollowUp.step === 0

  const handleAbTestToggle = (checked: boolean) => {
    setAbTestEnabled(checked)
  }

  return (
    <section
      id="campaign-step-editor"
      aria-label="Step editor"
      className="follow-up-editor"
    >
      <header className="follow-up-editor__header-card">
        <div className="follow-up-editor__header-left">
          <Icon icon="envelope" className="follow-up-editor__icon" size="sm" />
          <h2 className="follow-up-editor__title">
            {isOpeningEmail
              ? t("js.campaigns.content.opening_email")
              : t("js.campaigns.content.follow_up", {
                  step: currentFollowUp.step,
                })}
          </h2>
        </div>

        <div className="follow-up-editor__header-right">
          <span className="follow-up-editor__ab-toggle-label">
            {t("js.campaigns.content.ab_test_toggle")}
          </span>
          <Switch
            checked={abTestEnabled}
            onCheckedChange={handleAbTestToggle}
            disabled={!editable}
          />
        </div>
      </header>

      <EmailEditorCard key={currentFollowUp.id} followUp={currentFollowUp} />
    </section>
  )
}
